import styled from '@emotion/styled';

export const Title = styled.div`
  font-size: 1.75rem;
  letter-spacing: 1px;
  font-weight: 700;
  line-height: 1;
  color: ${({theme}) => theme.colors.contentInversePrimary};
`;
